import { render, staticRenderFns } from "./PhotoWallItem.vue?vue&type=template&id=66b15d89&scoped=true&"
import script from "./PhotoWallItem.vue?vue&type=script&lang=js&"
export * from "./PhotoWallItem.vue?vue&type=script&lang=js&"
import style0 from "./PhotoWallItem.vue?vue&type=style&index=0&id=66b15d89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b15d89",
  null
  
)

export default component.exports